module.exports = __webpack_public_path__ + "img/dd-dice-2.272ce5f7.png";